import { Injectable } from '@angular/core';
import {HttpService} from '../../core/lib/http.service'
import { OthersService } from '../../services/others/others.service'
import {Md5} from 'ts-md5/dist/md5';

@Injectable({
  providedIn: 'root'
})
export class CardService {

  apiurl:string = '';
  constructor(private otherService:OthersService, private httpService:HttpService) { 
      this.apiurl = this.otherService.getApiUrl();
  }


  getComCard(id:number) {
      return this.httpService.get(this.apiurl + '/v3/card/' + id, []);
  }

  getV3Comcard(id:number,compid:number, refresh:boolean=false) {
    const md5 = new Md5();
    const cardId = md5.appendStr(id.toString()).end()
    //return this.httpService.get(`${this.otherService.getZeroApi()}/api/v3/weblink/${cardId}?t=`+new Date().getTime(), [])
    console.log('API111:' + this.apiurl)
    return this.httpService.get(this.apiurl + '/v3/admin/company/'+compid+'/bcard/' + id, [])
  }

  getBCard(id) {
    return this.httpService.get(this.apiurl + '/v3/comcard/' + id, []);
  }


  getFirtComcard(id, data = null) {
    let filter = ''
    if(data) {
      filter = `?type=${data.type}`
    }
    return this.httpService.get(this.apiurl + '/v3/company/'+id+'/card/firstcomcard'+filter, []);
  }


  create(id,data:any) {
      return this.httpService.post(this.apiurl + '/v3/company/'+id+'/card/create', data);
  }

  createFC(cid:number,data:FormData) {
    
    return this.httpService.uploadFile(this.apiurl + '/v3/card/'+cid+'/createFC',data);
  }

  editLabel(id,cid,label) {
    return this.httpService.post(this.apiurl + '/v3/company/'+id+'/card/'+cid+'/label', {label:label});
  }

  updateDetail(id:number,cid:number,data:any) {
    return this.httpService.post(this.apiurl + '/v3/company/'+id+'/card/'+cid, data);
  }

  updateAllBC(id:number,cid:number,isall) {
    return this.httpService.post(this.apiurl + '/v3/company/'+id+'/card/'+cid + '/updatebc', {isall:isall});
  }

  updateDetail2(id:number,sid, cid:number,data:any) {
    return this.httpService.post(this.apiurl + '/v3/company/'+id+'/staff/'+sid+'/card/'+cid, data);
  }

  
  uploadImages(data:FormData) {
    
     return this.httpService.uploadFile(this.apiurl + '/v3/media',data);

  }


  getMedia(cid,data:object) {
    console.log('/v3/card/' + cid + '/media');
    return this.httpService.get(this.apiurl + '/v3/card/' + cid + '/media', data);
  }
  

  deleteComCard(id,cid) {
     return this.httpService.post(this.apiurl + '/v3/company/' + id + '/delcomcard/' + cid,{});
  }

  deleteCard(id,cid,sid) {
    return this.httpService.post(this.apiurl + '/v3/company/' + id + '/delcard/' + cid,{sid:sid});
  }


  enableCard(id,cid,status) {
    return this.httpService.post(this.apiurl + '/v3/company/' + id + '/enablecomcard/' + cid,{status:status});
  }


  enableBCard(id,cid,sid,status) {
    return this.httpService.post(this.apiurl + '/v3/company/' + id + '/enablecard/' + cid,{status:status,sid:sid});
  }

  getWalletSetting(compid,cardid) {
    return this.httpService.get(this.apiurl + '/v3/admin/company/' + compid + '/wallet/' + cardid,{});
  }


  setWalletSetting(compid, cardid,params:object) {
    return  this.httpService.post(this.apiurl + '/v3/admin/company/' + compid + '/wallet/' + cardid,params);
  }

  setWalletSettingWithUpload(compid,cardid:number,data:FormData) {
    
    return this.httpService.uploadFile(this.apiurl + '/v3/admin/company/' + compid + '/wallet/' + cardid,data);
  }

}


